var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5554 14.2777C28.5554 6.39215 22.1633 0 14.2777 0C6.39215 0 0 6.39215 0 14.2777C0 20.9739 4.60982 26.5919 10.8286 28.1352V18.6407H7.88444V14.2777H10.8286V12.3978C10.8286 7.53773 13.0278 5.28528 17.7986 5.28528C18.7035 5.28528 20.2642 5.46312 20.9027 5.6404V9.59552C20.5655 9.56017 19.9804 9.54222 19.2533 9.54222C16.9122 9.54222 16.0073 10.4292 16.0073 12.7349V14.2777H20.671L19.8699 18.6407H16.0073V28.4511C23.0771 27.5972 28.5554 21.5776 28.5554 14.2777Z",
    fill: "#11998E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8698 18.6406L20.671 14.2776H16.0073V12.7348C16.0073 10.4291 16.9122 9.5421 19.2533 9.5421C19.9804 9.5421 20.5655 9.56005 20.9027 9.5954V5.64028C20.2642 5.463 18.7035 5.28516 17.7986 5.28516C13.0278 5.28516 10.8286 7.53817 10.8286 12.3976V14.2776H7.88443V18.6406H10.8286V28.1351C11.9332 28.4089 13.0884 28.5553 14.2777 28.5553C14.8634 28.5553 15.4401 28.5194 16.0073 28.4509V18.6406H19.8698Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.5554,
    height: 28.5554,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.040e417ce04261293e93c4f1ca483427.svg";
export { ForwardRef as ReactComponent };